import { render, staticRenderFns } from "./CatalogDrawer.vue?vue&type=template&id=13c0a9e7&scoped=true&"
import script from "./CatalogDrawer.vue?vue&type=script&lang=js&"
export * from "./CatalogDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDrawer.vue?vue&type=style&index=0&id=13c0a9e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0a9e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
